import { gql } from "@/services/httpAdapter";

export const onUpdateTimeCard = gql`
	subscription onUpdateTimecard($locationId: String, $payPeriodId: String) {
		onUpdateTimecard(locationId: $locationId, payPeriodId: $payPeriodId) {
			locationId
			commissionCycleId
			payPeriodId
			userId
			fullName
			position
			timecards {
				date
				clockInType
				clockInTime
				clockOutType
				clockOutTime
				regular
				overtime
				totalPaid
				unpaid
			}
			createdAt
			updatedAt
		}
	}
`;

export const onUpdateWorkedHours = gql`
	subscription onUpdateWorkedHours($commissionCycleId: String, $payPeriodId: String) {
		onUpdateWorkedHours(commissionCycleId: $commissionCycleId, payPeriodId: $payPeriodId) {
			_id
			locationId
			commissionCycleId
			payPeriodId
			usersWorkedHours {
				user {
					_id
					fullName
					position
				}
				hours
			}
			createdAt
			updatedAt
		}
	}
`;

export const onCreatePayRate = gql`
	subscription onCreatePayRate($locationId: String!, $commissionCycleId: String!, $payPeriodId: String) {
		onCreatePayRate(locationId: $locationId, commissionCycleId: $commissionCycleId, payPeriodId: $payPeriodId) {
			locationId
			commissionCycleId
			payPeriodId
		}
	}
`;

export const onUpdatePto = gql`
	subscription onUpdatePto($locationId: String, $commissionCycleId: String, $payPeriodId: String) {
		onUpdatePto(locationId: $locationId, commissionCycleId: $commissionCycleId, payPeriodId: $payPeriodId) {
			_id
			locationId
			commissionCycleId
			payPeriodId
			usersPto {
				user {
					_id
					fullName
					position
				}
				hours
				payType
				payTypeCode
				payTypeID
				details {
					start
				}
			}
			createdAt
			updatedAt
		}
	}
`;

export const onUpdatePtoBalance = gql`
	subscription onUpdatePtoBalance($locationId: String, $commissionCycleId: String, $payPeriodId: String) {
		onUpdatePtoBalance(locationId: $locationId, commissionCycleId: $commissionCycleId, payPeriodId: $payPeriodId) {
			_id
			locationId
			commissionCycleId
			payPeriodId
			usersPto {
				user {
					_id
					fullName
					position
				}
				hours
				payType
				payTypeCode
				payTypeID
			}
			createdAt
			updatedAt
		}
	}
`;
